import { removeEmptyValuesInObject } from '@backmarket/utils/object/removeEmptyValuesInObject'

import type { EventData } from '../../types'
import { formatPrice } from '../../utils/formatPrice'

export function favoritesModel({
  brand,
  category,
  color,
  currency,
  hasNewBattery,
  model,
  name,
  position,
  price,
  productList = 'my_favorites',
  uuid,
  mobileDeeplink,
  listingId,
  image,
  webUrl,
  variant,
}: EventData) {
  return removeEmptyValuesInObject({
    product_brand: brand,
    product_category: category,
    product_color: color,
    product_hasNewBattery: hasNewBattery,
    product_id: uuid,
    product_list: productList,
    product_model: model,
    product_name: name,
    product_position: position,
    product_price: formatPrice({ amount: price, currency }),
    product_mobile_deeplink: mobileDeeplink,
    product_price_currency: currency,
    product_listingID: `${listingId}`,
    product_image: image,
    product_web_url: webUrl,
    product_variant: `${variant}`,
  })
}

export const favoritesModelCollection = (
  favoriteProducts: EventData[] = [],
) => {
  const favoriteProductsList = Array.isArray(favoriteProducts)
    ? favoriteProducts
    : [favoriteProducts]

  return favoriteProductsList.map((favoriteProduct, index) => ({
    ...favoritesModel({
      ...favoriteProduct,
      position: favoriteProduct.position || index + 1,
    }),
  }))
}
